import { MapPin } from "lucide-react";
import { SITE, IMG } from "@/lib/site";
import Chapter from "@/components/cinema/Chapter";
import { Reveal, LineReveal } from "@/components/cinema/Reveal";

export default function AreasChapter() {
  return (
    <Chapter img={IMG.torontoBlueHour} overlay="left" testId="service-areas">
      <div className="grid md:grid-cols-12 gap-12 items-center">
        <div className="md:col-span-6">
          <Reveal y={16}><div className="eyebrow eyebrow-light mb-5">Service Areas</div></Reveal>
          <LineReveal
            className="display-chunky text-4xl md:text-6xl xl:text-7xl text-white leading-[0.92] mb-8"
            lines={["If it's in the GTA,", <span className="text-[hsl(var(--gaza-blue-bright))]">we're already</span>, <span className="text-[hsl(var(--gaza-blue-bright))]">on the way.</span>]}
          />
          <Reveal delay={0.45}>
            <p className="text-white/75 leading-relaxed text-lg max-w-lg">Crews and contents specialists positioned across the region. Same standard of service in every market we serve.</p>
          </Reveal>
        </div>
        <div className="md:col-span-6 grid grid-cols-2 sm:grid-cols-3 gap-3">
          {SITE.serviceAreas.map((c, i) => (
            <Reveal key={c} delay={0.2 + i * 0.05} y={16}>
              <div className="city-pill bg-white/[0.06] backdrop-blur-md border border-white/15 px-5 py-4 flex items-center gap-2.5" data-testid={`area-${c.toLowerCase()}`}>
                <MapPin className="w-4 h-4 text-[hsl(var(--gaza-blue-bright))]" />
                <span className="text-sm font-bold text-white">{c}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </Chapter>
  );
}
